var $ = require('jquery');

/** @module */
var cursor = {};

/**
 * Get the current cursor position
 * @param {JQuery} $input
 * @return {Number}
 */
cursor.get = function ($input) {
  var input = $input[0];

  if (!input) {
    return;
  }

  // cool-kid browsers
  if (input.selectionStart) {
    return input.selectionStart;
  } else if (!document.selection) {
    return 0;
  }

  // IE
  var cursorChar = Global.octalCursorChar,
    selection = document.selection.createRange(),
    duplicate = selection.duplicate(),
    l = 0;

  duplicate.moveToElementText(input);
  selection.text = cursorChar;
  l = duplicate.text.indexOf(cursorChar);
  selection.moveStart('character', -1);
  selection.text = '';
  return l;
};

/**
 * Set the current cursor position
 * @param {JQuery} $input
 * @param {Number} position
 */
cursor.set = function ($input, startPosition, endPosition) {
  var input = $input[0];
  endPosition = endPosition || startPosition;

  if (!input) {
    return;
  }

  // IE
  if (input.createTextRange) {
    var range = input.createTextRange();
    range.move('character', startPosition);
    range.select();

    // others
  } else {
    if (input.selectionStart) {
      input.focus();
      input.setSelectionRange(startPosition, endPosition);
    } else {
      input.focus();
    }
  }
};

/**
 * Insert text are the cursor position (note: does not reposition cursor)
 * @param {JQuery} $input
 * @param {String} text
 * @param {Number} position
 */
cursor.insert = function ($input, text, position) {
  var input = $input[0];

  if (!input) {
    return;
  }

  //IE support
  if (document.selection) {
    input.focus();
    sel = document.selection.createRange();
    sel.text = text;

    // others
  } else if (input.selectionStart || input.selectionStart == '0') {
    input.value =
      input.value.substring(0, position) +
      text +
      input.value.substring(position, input.value.length);
  } else {
    input.value += text;
  }

  input.dispatchEvent(new Event('input'));
};

module.exports = cursor;
